<script lang="ts">
    import {WalkerService} from 'shared/services';
    import {ActionRequestDataService} from 'shared/data-services';
    import {getInjector} from 'src/core';
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import type {SubmittingFormActionModel} from './types';
    import KpUniversalFormModal from 'src/modals/universal-form-modal/KpUniversalFormModal.svelte';
    import type {UniversalFormModalModel} from 'src/modals/universal-form-modal/types';

    export let model: SubmittingFormActionModel;
    export let modalWindowActions: ModalWindowActions;

    const actionRequestDataService = getInjector().getByClass(ActionRequestDataService);
    const walkerService = getInjector().getByClass(WalkerService);

    function createUniversalFormModel(submittingFormModel: typeof model): UniversalFormModalModel {
        return {
            formObject: submittingFormModel.formObject,
            formSetting: submittingFormModel.formSetting,
            submitFunction
        }
    }

    const submitFunction = (transferableFormObject: Record<string, any>) => {
        if (model.submitAsPage) {
            return Promise.resolve(walkerService.newPage(model.submitPath, transferableFormObject));
        }
        return actionRequestDataService.request(model.submitPath, model.submitMethod, transferableFormObject);
    }
</script>


<KpUniversalFormModal {modalWindowActions} model={createUniversalFormModel(model)}/>
